import { Component, OnInit, inject } from '@angular/core'
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { logout } from '../../store/user.actions';
import { isAuthenticatedSelector } from '../../store/user.selectors';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../../shared/services/authentication.service';

@Component ({
    selector: 'user-logout',
    template: '',
    standalone: false
})

export class UserLogoutComponent implements OnInit {
    private store = inject(Store);
    private router = inject(Router);
    private authenticationService = inject(AuthenticationService);
    
    isAuthenticated$: Observable<boolean> = this.store.select(isAuthenticatedSelector);

    ngOnInit() {
      this.logout();
    }  

    logout() {
      this.authenticationService.clearUserToken();
      this.store.dispatch(logout());
      this.isAuthenticated$.subscribe(x => {
        if (!x) {
          this.router.navigate(['/']);
        }
      });
    }  

}